'use client';

import { FC } from 'react';
import { CatButton } from 'components/blocks-components';
import { HEADLESS_PRODUCT_PAGE } from 'constants/links';
import { usePathMatch } from 'hooks/use-path-match';
import { useTranslations } from 'next-intl';
import { useParams } from 'next/navigation';
import { getSeoUrl } from 'utils/links';

interface AlternatePartReplaceButtonProps {
  partNumber: string;
}

const AlternatePartReplaceButton: FC<AlternatePartReplaceButtonProps> = ({
  partNumber
}) => {
  const t = useTranslations();
  const params = useParams();
  const esiteUrl = getSeoUrl(params);
  const isProductDisplayPage = usePathMatch(HEADLESS_PRODUCT_PAGE);
  const productLink = isProductDisplayPage
    ? partNumber
    : `${esiteUrl}/${partNumber}`;

  return (
    <CatButton
      className="pt-5 pb-2"
      size="sm"
      variant="contrast"
      fullWidth
      href={productLink}
    >
      {t('REPLACEMENT_BUTTON')}
    </CatButton>
  );
};

export default AlternatePartReplaceButton;
